import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Container, Typography } from "@mui/material";
import NativePlayer from "../NativePlayer/NativePlayer";
import PhotoView from "../PhotoView/PhotoView";
import PostHeader from "../Collection/PostHeader";
import PostDetail from "../Collection/PostDetail";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import postedOn from "../Collection/postedOn";
import AmbassadorHelper from "../../utils/AmbassadorHelper";
import common from "../../utils/common";
import { LAYOUT } from "../../configuration/theme";

const getPhotoSource = (content) =>
    content.asset && content.asset.sources && content.asset.sources.length > 0 ? content.asset.sources[0]?.url : "";

const PostModal = ({ open = false, asset, position = 0, total = 0, onPrev, onNext, onClose, children }) => {
    const [sessionId] = useState(() => common.generateSessionId());

    if (!asset) {
        return null;
    }

    const creator = asset.creator || {};
    const ambassador = creator.creator_id ? { ...creator, id: creator.creator_id } : null;
    const isVideo = asset.entityType === 1;
    const video = {
        ...asset,
        loginId: asset.loginId || ConfigurationHelper.getGlobalConfiguration().loginId,
    };

    if (!open) {
        return null;
    }

    return (
            <Box
                data-testid="tvp-post-view"
                sx={{
                    width: "100vw",
                    marginLeft: "calc(50% - 50vw)",
                    marginRight: "calc(50% - 50vw)",
                    backgroundColor: "#fff",
                }}
            >
                <Breadcrumbs
                    renderStructureData={false}
                    breadcrumbsList={[
                        { name: "Creators", url: ConfigurationHelper.getGlobalConfiguration().sub_folder || "/" },
                        ...(creator.full_name
                            ? [{ name: creator.full_name, url: common.generateCreatorUrl(creator) || "#" }]
                            : []),
                        { name: asset.title, url: "#", active: true },
                    ]}
                />
                <PostHeader
                    ambassador={ambassador}
                    avatar={AmbassadorHelper.getCreatorPhoto(creator)}
                    displayName={creator.full_name}
                    storefrontUrl={common.generateCreatorUrl(creator) || undefined}
                    position={position}
                    total={total}
                    onPrev={onPrev}
                    onNext={onNext}
                    onClose={onClose}
                />
                <PostDetail
                    content={asset}
                    posted={postedOn(asset.creation_date)}
                    products={asset.products}
                    userId={creator.creator_id}
                    headingLevel={"h2"}
                >
                    {isVideo ? (
                        <NativePlayer
                            video={video}
                            sessionId={sessionId}
                            index={position}
                            activePosition={position}
                            active={open}
                            autoplay={true}
                            handleCloseModal={onClose}
                        />
                    ) : (
                        <PhotoView handleCloseModal={onClose} src={getPhotoSource(asset)} photo={asset} />
                    )}
                </PostDetail>
                {children && (
                    <Box
                        sx={{
                            backgroundColor: (t) => t.tvp.surface,
                            pt: LAYOUT.gridPadY,
                            pb: LAYOUT.gridPadBottom,
                        }}
                    >
                        {creator.full_name && (
                            <Container sx={{ px: LAYOUT.pagePad }}>
                                <Typography
                                    component={"h3"}
                                    sx={{ fontSize: "20px", fontWeight: 700, lineHeight: 1.25, margin: "0 0 14px" }}
                                >
                                    {`More from ${creator.full_name}`}
                                </Typography>
                            </Container>
                        )}
                        {children}
                    </Box>
                )}
            </Box>
    );
};


PostModal.propTypes = {
    open: PropTypes.bool,
    asset: PropTypes.object,
    position: PropTypes.number,
    total: PropTypes.number,
    onPrev: PropTypes.func,
    onNext: PropTypes.func,
    onClose: PropTypes.func.isRequired,
};

export default PostModal;
